/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import gql from 'graphql-tag';

import useRouter from 'js/lib/useRouter';

import { SelectOption, SilentSelectField } from '@coursera/cds-core';
import type { Country } from '@coursera/grpc-types-countrynames/coursera/proto/countrynames/v1/country_names';

import _t from 'i18n!nls/partners-graphql';

export const CountryNamesQuery = gql`
  query CountryNamesFilterQuery($countryNamesQueryInput: MultiGetCountryNamesRequest!) {
    MultiGetCountryNames(input: $countryNamesQueryInput)
      @rest(
        type: "MultiGetCountryNames"
        path: "grpc/countrynames/v1/CountryNamesAPI/MultiGetCountryNames"
        method: "POST"
      ) {
      countries
    }
  }
`;

type Props = {
  countries: Country[];
  selectedCountry: string;
};

const styles = {
  filterContainer: css`
    margin: var(--cds-spacing-200) 0;
    max-width: 240px;
  `,
};

const PartnerCountryFilter = ({ countries, selectedCountry }: Props) => {
  const router = useRouter();

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const value = event.target.value as string;
    if (value) {
      router.push(`/partners?countryCode=${value.toLowerCase()}`);
    } else {
      router.push('/partners');
    }
  };

  return (
    <div css={styles.filterContainer} data-testid="partner-country-filter">
      <SilentSelectField
        label={_t('Filter country')}
        labelPlacement="none"
        placeholder={_t('Filter country')}
        value={selectedCountry?.toUpperCase() || ''}
        onChange={handleChange}
      >
        {[
          <SelectOption key="all" value="">
            {_t('Filter country')}
          </SelectOption>,
          ...countries.map((country) => (
            <SelectOption key={country.isoAlpha2Code} value={country.isoAlpha2Code}>
              {country.name}
            </SelectOption>
          )),
        ]}
      </SilentSelectField>
    </div>
  );
};

export default PartnerCountryFilter;
